import { T } from '../Text/Text'

import { SelectOption } from './types'

type Props<TValue> = {
  index: number
  option: SelectOption<TValue>
  options: SelectOption<TValue>[]
}
const SelectMenuItemGroupLabel = <TValue,>({ index, option, options }: Props<TValue>) => {
  if (!option.group) {
    return null
  }
  if (index > 0 && options[index - 1]?.group === option.group) {
    return null
  }

  return (
    <T.BodySmall className="col-span-full rounded-sm bg-neutral-100 px-4 py-1 text-neutral-500">
      {option.group}
    </T.BodySmall>
  )
}

export default React.memo(SelectMenuItemGroupLabel) as typeof SelectMenuItemGroupLabel
